module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "h1 header"
  }, [_vm._v("News & Announcements")]), _vm._v(" "), _vm._l((_vm.entries), function(entry) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('ul', {
      staticClass: "inline nospace small-text text-muted",
      staticStyle: {
        "margin-bottom": "4px"
      }
    }, [_c('li', [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": entry.author.avatar,
        "width": "28px",
        "height": "28px"
      }
    })]), _vm._v(" "), _c('li', [_vm._v(_vm._s(entry.author.name))]), _vm._v(" "), _c('li', [_vm._v("•")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(entry.date))])]), _vm._v(" "), _c('div', {
      staticClass: "h2"
    }, [_vm._v(_vm._s(entry.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(entry.content)
      }
    }), _vm._v(" "), _c('hr')])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d302c4e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 32
// module chunks = 0